module.exports = __webpack_public_path__ + "b0fb022db096a714a3080d603822dcca.svg";